import gql from 'graphql-tag'

export default gql`
  query CompanyLeaveTypes($company: ID!) {
    companyProfile(company: $company) {
      leaveTypes {
        id
        name
        colour
        description
        approval
        display_icon: displayIcon
        is_default: isDefault
        is_private: isPrivate
        is_reason_public: isReasonPublic
        only_admin: onlyAdmin
        accounts_to_conflicts: accountsToConflicts
        allowance_type_id: allowanceTypeId
      }
    }
  }
`
